// Utility functions for production dashboard

/**
 * Format number to Indonesian locale
 */
export const formatNumber = (value: number, type: 'number' | 'percent' | 'currency' = 'number'): string => {
    if (type === 'percent') {
        return `${(value as number).toFixed(2)}%`;
    }
    if (type === 'currency') {
        return new Intl.NumberFormat('id-ID', {
            style: 'currency',
            currency: 'IDR',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(value);
    }
    if (type === 'number') {
        return new Intl.NumberFormat('id-ID', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(value);
    }
    return new Intl.NumberFormat('id-ID').format(value);
};

export const formatNumber2Digits = (value: number, type: 'number' | 'percent' | 'currency' = 'number'): string => {
    if (type === 'percent') {
        return `${(value * 100).toFixed(2)}%`;
    }
    if (type === 'currency') {
        return new Intl.NumberFormat('id-ID', {
            style: 'currency',
            currency: 'IDR',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(value);
    }
    if (type === 'number') {
        return new Intl.NumberFormat('id-ID', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(value);
    }
    return new Intl.NumberFormat('id-ID').format(value);
};

/**
 * Format percentage
 */
export const formatPercentage = (num: number): string => {
    return num.toLocaleString('id-ID', { 
        minimumFractionDigits: 2,
        maximumFractionDigits: 2 
    }) + '%';
};
